import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useEventRevenueMetrics({
  eventId,
  start,
  end,
  groupBy = "none",
  enabled = true,
}) {
  const { getRevenueMetrics } = useApiV2();
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;

  return useQuery({
    queryKey: [
      "eventRevenueMetrics",
      user?.user_id ?? null,
      branchId,
      eventId,
      start,
      end,
      groupBy,
    ],
    queryFn: () =>
      getRevenueMetrics({
        branch_id: branchId,
        event_id: eventId,
        start,
        end,
        group_by: groupBy,
      }),
    enabled: enabled && !!branchId && !!eventId && !!start && !!end,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
